export default "__VITE_ASSET__f375afa2__"